export const CATEGORIES_SET = 'set_categories';
export const NODE_SET = 'set_node';
export const NODE_SYNC_FINISHED = 'node_sync_was_initiated';
export const NODE_SYNC_INITIATED = 'node_sync_has_finished';
export const PATHS_SET = 'set_paths';
export const SYNC_FAILED = 'categories_sync_error';
export const SYNC_FINISHED = 'categories_sync_has_finished';
export const SYNC_INITIATED = 'categories_sync_was_initiated';
